import type { intlFormatPropTypes } from "react-intl";

/** Localized `use_type` labels keyed by the backend's listing `use_type`. */
export const USE_TYPE_LABELS = {
  Event: {
    defaultMessage: "Event",
    id: "hosting.toc_by_use_type.option_label_event",
  },
  "Off-Site": {
    defaultMessage: "Meeting",
    id: "hosting.toc_by_use_type.option_label_off-site",
  },
  Production: {
    defaultMessage: "Production",
    id: "hosting.toc_by_use_type.option_label_production",
  },
} as const;

/**
 * Resolves a listing row label as `"[Space Name] - [Listing Type]"`, localizing
 * the listing type and gracefully omitting either part when it is missing.
 */
export const formatListingRowTitle = ({
  intl,
  spaceTitle,
  useType,
}: {
  intl: intlFormatPropTypes;
  spaceTitle?: string;
  useType?: string;
}): string => {
  const useTypeMessage =
    useType && useType in USE_TYPE_LABELS
      ? USE_TYPE_LABELS[useType as keyof typeof USE_TYPE_LABELS]
      : undefined;
  const useTypeLabel = useTypeMessage
    ? intl.formatMessage(useTypeMessage)
    : useType;

  return [spaceTitle, useTypeLabel].filter(Boolean).join(" - ");
};
